import React from "react";
import { Field } from 'redux-form/immutable';
import { SelectField } from 'redux-form-antd';
import {
    required, nullValue0
} from '../../validDesc';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
}

const ClubMondaySelect = props => {
    const club_monday_select = [
        {
            label: '-- 請選擇 --',
            value: '0'
        },
        {
            value: '138',
            label: '4:50自接'
        },
        {
            value: '100',
            label: '安親1-2年級'
        },
        {
            value: '115',
            label: '籃球1年級'
        },
        {
            value: '121',
            label: 'Scratch電腦程式設計初階1-2年級'
        },
        {
            value: '124',
            label: '珠心算基礎班'
        },
        {
            value: '125',
            label: '創意黏土社初階—【動物狂想曲】'
        },
        {
            value: '126',
            label: '陶藝—【生活陶】'
        },
        {
            value: '128',
            label: '玩劇總動員1-2年級'
        },
        {
            value: '129',
            label: '西班牙語'
        },
        {
            value: '130',
            label: '西洋棋初階1-3年級'
        },
        {
            value: '131',
            label: '鋼琴'
        },
        {
            value: '132',
            label: '小提琴'
        },
    ]
    const club_monday_display_options = club_monday_select.map(item => (
        item.value === '0' ? item : { ...item, label: `[${item.value}]${item.label}` }
    ));
    return (
        <div>
             <Field {...formItemLayout} validate={[required, nullValue0]} component={SelectField} label="星期一"
                options={club_monday_display_options} name="club_monday" type="text"></Field>
        </div>
    )
}

export default ClubMondaySelect



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudentClubForm/ClubMondaySelect.jsx